<template>
    <div>
        <legend v-if="is_registar">ユーザ一括登録</legend>
        <legend v-else>ユーザ一括削除</legend>
        <div class="container">
            <div class="mb-3">
                <label>スプレッドシートのURL</label>
                <div class="input-group">
                    <button class="btn btn-outline-secondary" type="button" @click="clear()">
                        <TablerIcon name="IconReload" />クリア
                    </button>
                    <input type="text" id="url" v-model="url" class="form-control"
                        @keydown.enter="getSheets($event)"
                        placeholder="URLを貼り付けてEnter">
                    <button class="btn btn-primary" type="button" @click="getSheets($event)">
                        <TablerIcon name="IconDownload" />読み込み
                    </button>
                </div>
                <div class="small">
                    空のスプレッドシートを作成し、システム部（system@socialtech.co.jp）に共有してください。<br>
                    スプレッドシートのURLを貼り付け、Enterキーを押してください。
                </div>
            </div>
            <div class="mb-3" v-if="sheets.length > 0">
                <label>シート選択</label>
                <div>
                    <label class="btn btn-outline-success me-2" :class="{active: v == sheet}"
                        v-for="(v, i) in sheets" :key="i">
                        <input type="radio" v-model="sheet" :value="v" class="d-none" @change="selectSheet()">
                        <TablerIcon name="IconCircleCheck" v-if="v == sheet" />
                        <TablerIcon name="IconCircle" v-else />
                        {{v}}
                    </label>
                </div>
                <div class="small">
                    取込用のシートを選択してください。
                    空のシートを選択した場合、取込に必要なヘッダ情報を書き込みます。
                </div>
            </div>
            <div class="mb-3" v-if="init">
                <label>インポートデータ確認（先頭３件まで確認）</label>
                <div class="d-grid">
                    <button class="btn btn-outline-primary" @click="importCheck()">
                        <TablerIcon name="IconSearch" />
                        インポート確認
                    </button>
                </div>
                <div class="small">
                    インポートデータを確認します。
                    この時点ではインポートしません。
                </div>
            </div>
            <div class="mb-3" v-if="check.length > 0">
                <label>インポートデータサンプル</label>
                <div class="d-flex justify-content-start">
                    <div v-for="(c, i) in check" :key="i" class="card p-2" :class="{'ms-1': i > 0}">
                        <div v-for="(v, k) in c" :key="i + '_' + k">
                            <span v-if="v === '新規'" class="badge bg-primary">{{v}}</span>
                            <span v-else-if="v === '削除'" class="badge bg-danger">{{v}}</span>
                        </div>
                        <div v-for="(v, k) in c">
                            【{{k}}】{{v}}
                        </div>
                    </div>
                </div>
                <div class="small">
                    上記データで間違いなければインポートを実行してください。
                </div>
            </div>
            <div class="mb-3" v-if="check.length > 0">
                <label>インポート実行</label>
                <div class="d-grid">
                    <button class="btn btn-outline-warning" @click="importData()">
                        <TablerIcon name="IconFileImport" />
                        インポート実行
                    </button>
                </div>
                <div class="small">
                    インポートを実行します。
                    重複してインポートを実行しても取り込まれません。
                </div>
            </div>
            <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
        </div>
    </div>
</template>

<style scoped>
.container {
    max-width: 1000px;
}
</style>

<script>
export default {
    data() {
        return {
            url: null,
            sheets: [],
            sheet: null,
            init: false,
            check: [],
            isLoading: false,
        }
    },
    methods: {
        clear() {
            this.init = false;
            this.check = [];
            this.sheet = null;
            this.sheets = [];
            this.url = null;
        },
        getSheets(ev) {
            this.isLoading = true;
            axios.get("/tools/bulkUsers/sheets", {params: {
                url: this.url,
            }}).then(res => {
                this.sheets = res.data;
                this.isLoading = false;
            }).catch(err => {
                Alert.err(err);
                this.isLoading = false;
            });
        },
        selectSheet() {
            if (!this.sheet) return;
            this.init = false;
            this.isLoading = true;
            // シートが空かどうかをまず見に行き、空なら初期化
            axios.get("/tools/bulkUsers/init" , {params : {
                url: this.url,
                sheet: this.sheet,
                is_registar: this.is_registar,
            }}).then(res => {
                if (res.data) {
                    this.init = true;
                    this.isLoading = false;
                    Alert.msg("初期化完了");
                };
            }).then(res => {
                // 初期化していない場合はシートを読み込む
                if (this.init === false) {
                    axios.get("/tools/bulkUsers/select", {params: {
                        url: this.url,
                        sheet: this.sheet,
                        is_registar: this.is_registar,
                    }}).then(res => {
                        Alert.msg("対象シートを読み込みました");
                        this.isLoading = false;
                        this.init = true;
                    }).catch(err => {
                        Alert.err(err);
                        this.isLoading = false;
                    });
                }
            }).catch(err => {
                Alert.err(err);
                this.isLoading = false;
            });
        },
        importCheck() {
            this.isLoading = true;
            axios.get("/tools/bulkUsers/check", {params: {
                url: this.url,
                sheet: this.sheet,
                is_registar: this.is_registar,
            }}).then(res => {
                if (res.data) {
                    this.setCheck(res.data);
                    Alert.msg("対象データを読み込みました");
                } else {
                    this.check = [];
                }
                this.isLoading = false;
            }).catch(err => {
                Alert.err(err);
                this.isLoading = false;
            });
        },
        setCheck(data) {
            this.check = [];
            if (Array.isArray(data)) {
                for (let i = 0; i < data.length; i++) {
                    if (i >= 3) break;
                    this.check.push(data[i]);
                }
            }
        },
        importData() {
            this.isLoading = true;
            axios.post("/tools/bulkUsers/import", {
                url: this.url,
                sheet: this.sheet,
                is_registar: this.is_registar,
            }).then(res => {
                Alert.msg("インポートが完了しました。");
                this.isLoading = false;
            }).catch(err => {
                Alert.err(err.response);
                this.isLoading = false;
            });
        },
    },
    mounted() {
        this.clear();
    },
    watch: {
        // 一括作成、一括削除のページを行き来する場合はクリア
        '$route.path'(to_path, from_path) {
            if (to_path !== from_path) {
                this.clear();
            }
        }
    },
    computed: {
        is_registar() {
            return this.$route.path === '/VNeCbSUJnsy5fMQk2ENw'
        }
    }
}
</script>
